export default __webpack_public_path__ + "125847325389be5efaabb22c1d0af28e.svg";